const BrandKonstrucktor = {
    namespaced: true,
    state: {
        //new code
         konstruktor_word:null,
        savedProjectName: '',









        /*To Show current view*/
        selectReport: null,
        currentStep: 1,
        resultReady: false,
        kronstuctSubmitComplete: false,

        foreignize: [],
        foreignizeBrandNames: [],

        randomgenerator: [],
        randomgeneratorBrandNames: [],

        urbanize: [],
        urbanizeBrandNames: [],

        abbreviate: [],
        abbreviateBrandNames: [],

        userKonstruktChoice: [],
        historyChoice: true,

        //////////////////////////////////
        ////////LOADER/////////////////////
        //////////////////////////////////

        foreignizeLoaderKeyword: true,
        foreignizeLoaderBrandname: true,

        RandomGeneratorLoaderKeyword: true,
        RandomGeneratorLoaderBrandname: true,

        UrbanizeLoaderKeyword: true,
        UrbanizeLoaderBrandname: true,

        AbbreviateLoaderKeyword: true,
        AbbreviateLoaderBrandname: true,


        //////////////////////////////////
        ////////READY/////////////////////
        //////////////////////////////////

        foreignizeReadyKeyword: false,
        foreignizeReadyBrandname: false,

        RandomGeneratorReadyKeyword: false,
        RandomGeneratorReadyBrandname: false,

        UrbanizeReadyKeyword: false,
        UrbanizeReadyBrandname: false,

        AbbreviateReadyKeyword: false,
        AbbreviateReadyBrandname: false,


    },
    mutations: {
        //new code
        setkonstruktorword:function(state,payload){
            state.konstruktor_word = payload;
        },
        setSavedProjectName:function(state,payload){
            state.savedProjectName = payload;
        },






        setresultReady: function (state, payload) {
            state.resultReady = payload;
        },
        setkronstuctSubmitComplete: function (state, payload) {
            state.kronstuctSubmitComplete = payload;
        },
        setForeignize: function (state, payload) {
            state.foreignize = payload;
        },
        setforeignizeBrandNames: function (state, payload) {
            state.foreignizeBrandNames = payload;
        },
        setabbreviate: function (state, payload) {
            state.abbreviate = payload;
        },
        setabbreviateBrandNames: function (state, payload) {
            state.abbreviateBrandNames = payload;
        },
        seturbanize: function (state, payload) {
            state.urbanize = payload;
        },
        seturbanizeBrandNames: function (state, payload) {
            state.urbanizeBrandNames = payload;
        },
        setrandomgenerator: function (state, payload) {
            state.randomgenerator = payload;
        },
        setrandomgeneratorBrandNames: function (state, payload) {
            state.randomgeneratorBrandNames = payload;
        },
        setuserKonstruktChoice: function (state, payload) {
            state.userKonstruktChoice = payload;
        },


        //Foreignize
        setforeignizeLoaderKeyword: function (state, payload) {
            state.foreignizeLoaderKeyword = payload;
        },
        setforeignizeLoaderBrandname: function (state, payload) {
            state.foreignizeLoaderBrandname = payload;
        },
        //RandomGenerator
        setRandomGeneratorLoaderKeyword: function (state, payload) {
            state.RandomGeneratorLoaderKeyword = payload;
        },
        setRandomGeneratorLoaderBrandname: function (state, payload) {
            state.RandomGeneratorLoaderBrandname = payload;
        },
        //Urbanize
        setUrbanizeLoaderKeyword: function (state, payload) {
            state.UrbanizeLoaderKeyword = payload;
        },
        setUrbanizeLoaderBrandname: function (state, payload) {
            state.UrbanizeLoaderBrandname = payload;
        },
        //Abbreviate
        setAbbreviateLoaderKeyword: function (state, payload) {
            state.AbbreviateLoaderKeyword = payload;
        },
        setAbbreviateLoaderBrandname: function (state, payload) {
            state.AbbreviateLoaderBrandname = payload;
        },


        ////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////
        //Foreignize
        setforeignizeReadyKeyword: function (state, payload) {
            state.foreignizeReadyKeyword = payload;
        },
        setforeignizeReadyBrandname: function (state, payload) {
            state.foreignizeReadyBrandname = payload;
        },
        //RandomGenerator
        setRandomGeneratorReadyKeyword: function (state, payload) {
            state.RandomGeneratorReadyKeyword = payload;
        },
        setRandomGeneratorReadyBrandname: function (state, payload) {
            state.RandomGeneratorReadyBrandname = payload;
        },
        //Urbanize
        setUrbanizeReadyKeyword: function (state, payload) {
            state.UrbanizeReadyKeyword = payload;
        },
        setUrbanizeReadyBrandname: function (state, payload) {
            state.UrbanizeReadyBrandname = payload;
        },

        //Abbreviate
        setAbbreviateReadyKeyword: function (state, payload) {
            state.AbbreviateReadyKeyword = payload;
        },
        setAbbreviateReadyBrandname: function (state, payload) {
            state.AbbreviateReadyBrandname = payload;
        },
        ////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////


        setselectReport: function (state, payload) {
            state.selectReport = payload;
        }


    },
    actions: {

        getHistory: function (state, payload) {

            this.dispatch('BrandKonstruktorSearchHistory/getHistory', payload, {root: true})
                .then(

                    response => {

                        this.commit('BrandKonstruktorSearchHistory/setHistory', response.data, {root: true});
                        // this.commit('BrandKonstruktorSearchHistory/setTotalRecord', response.data.total, {root: true});
                        // this.commit('BrandKonstruktorSearchHistory/setPreviousUrl', response.data.prev_page_url, {root: true});
                        // this.commit('BrandKonstruktorSearchHistory/setNextUrl', response.data.next_page_url, {root: true});
                    },
                    error => {
                        console.error(error)
                    });

        },

        submitSearch: function (state, payload) {

            this.dispatch('BrandKonstruktorKonstruct/submitSearch', payload, {root: true}).then(response => {
                    if (response.status === 200) {
                        state.commit('setkronstuctSubmitComplete', true);

                    }
                },
                error => {
                    console.error(error)
                });
        },

        setSavedProjectName: function(store, payload) {
            store.commit('setSavedProjectName', payload);
        }
    },
    getters: {
        savedProjectName(state) {
            return state.savedProjectName;
        }
    },
}
export default BrandKonstrucktor
